package pwgs.ui.scenes.trialsettingsscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ATrialSettingsControllerFe(props: pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneProps, scene: MTrialSettingsScene)
 : AController<pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneProps, pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel, TrialSettingsSceneState>(props, scene) {

    val backend = TrialSettingsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_startTrialSeason(days: kotlin.Int) {
        launchOnDefaultControllerScope {
            render(backend.startTrialSeason(days))
        }
    }

    fun call_stopTrialSeason() {
        launchOnDefaultControllerScope {
            render(backend.stopTrialSeason())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class TrialSettingsControllerBeProxy(private val controller: ATrialSettingsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.trialsettingsscene.TrialSettingsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel.serializer())
        }
    }

    suspend fun startTrialSeason(days: kotlin.Int): pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel {
        @Serializable
        class ParamsWrapper(val days: kotlin.Int)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(days))
        val p = RmiParams(
            action = "pwgs.ui.scenes.trialsettingsscene.TrialSettingsControllerBe.startTrialSeason",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel.serializer())
        }
    }

    suspend fun stopTrialSeason(): pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.trialsettingsscene.TrialSettingsControllerBe.stopTrialSeason",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.trialsettingsscene.TrialSettingsSceneModel.serializer())
        }
    }

}
